import { render, staticRenderFns } from "./Deductions.vue?vue&type=template&id=7e931402&scoped=true&"
import script from "./Deductions.vue?vue&type=script&lang=js&"
export * from "./Deductions.vue?vue&type=script&lang=js&"
import style0 from "./Deductions.vue?vue&type=style&index=0&id=7e931402&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e931402",
  null
  
)

export default component.exports